import * as React from 'react'
import styled from 'styled-components'

import { t } from '@owl-nest/localize'
import * as service from '@owl-nest/services'
import * as plume from '@ulule/owl-kit-components/next'

import * as S from './styles'

type IdentityProps = {
  className?: string
}

function IdentityComponent({ className }: IdentityProps): React.ReactElement<IdentityProps> | null {
  const auth = service.user.useAuth()

  if (auth.type === 'loggedin') {
    return (
      <S.IdentityBlock className={className}>
        <plume.styles.image.Avatar type="medium" src={auth.user.avatar.versions['128x128'].url} />
        <S.IdentityGroup>
          <S.IdentitySmallText>
            {t('Logged in as ')} {auth.user.email}
          </S.IdentitySmallText>
          <plume.Link kind="secondary" onClick={auth.logout}>
            {t('Switch my account')}
          </plume.Link>
        </S.IdentityGroup>
      </S.IdentityBlock>
    )
  }
  if (auth.type === 'known') {
    return (
      <S.IdentityBlock className={className}>
        <plume.styles.image.Avatar type="medium" src={auth.knownUser.avatar.versions['55x55'].url} />
        <S.IdentityGroup>
          <S.IdentityUsernameWrapper>{auth.knownUser.username}</S.IdentityUsernameWrapper>
          <plume.Link onClick={auth.forget}>{t('Not you?')}</plume.Link>
        </S.IdentityGroup>
      </S.IdentityBlock>
    )
  }
  return null
}

export const Identity = styled(IdentityComponent)``
